import {
    ArrowRightIcon,
    Button,
    Dialog,
    Dropdown,
    Flex,
    Image,
    Input,
    Loader,
    Text,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Container } from "../../../common/styles";
import UserCard from "./ui/UserCard";
import { DetailOffboardingHeader } from "./ui/DetailOffboardingHeader";
import styled from "styled-components";

import { DetailOffboardingArchivedCard } from "./ui/DetailOffboardingArchivedCard";
import { OffBoardingArchivedActions } from "./ui/OffBoardingArchivedActions";
import { HistoriqueArchivedCollab } from "./HistoriqueArchivedCollab";
import Sharepoint from "../../../assets/illustrations/offboarding/Sharepoint.svg";
import { PersonArrowRight20Regular } from "@fluentui/react-icons";
import { useMutation, useQuery } from "react-query";
import {
    _getOffboardingArchiveduser,
    relance_onboarding_user_from_offboarding,
} from "../api";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Toast } from "@fluentui/react-components";
import { useToastGlobal } from "../../../stores/useToastGlobal";
export const OffboardingArchivedCollabPage = () => {
    const location = useLocation();
    const [params, setParams] = useSearchParams();
    const [toastConfig, setToastConfig] = useState({
        content: "",
        visible: false,
        level: "warning",
    });
    const activeTab = params.get("subtab");

    const toast = useToastGlobal();

    const { user } = location.state;

    // const archivedUserDetails = {
    //     id: 289,
    //     username: "raya@yopmail.com",
    //     name: "Raya BOUALLEGUE",
    //     avatar: "",
    //     department: {
    //         id: 2,
    //         name: "Ressources humaines",
    //     },
    //     agency: {
    //         id: 2,
    //         name: "Asendit Genève",
    //     },
    //     start_date: "2024-09-23",
    //     probationary_period_end_date: "2024-10-21",
    //     end_date: null,
    //     seniority: {
    //         year: 0,
    //         month: 4,
    //         seniority_text: "4 mois",
    //     },
    //     onboarding_tasks_done: [],
    //     history: [
    //         {
    //             date: "2024-12-03",
    //             status: 1,
    //             status_text: "Actif",
    //             status_description: "Clôture de l'Onboarding",
    //             processed_by_name: "Foued SAIDANE",
    //             processed_by_avatar:
    //                 "https://asenditbackenddevstorage.blob.core.windows.net/documents/asendit/users/16/profile_photo/profile.jpeg?se=2025-01-31T13%3A43%3A53Z&sp=r&sv=2021-06-08&sr=b&sig=nCAY99NXJW4QKeUCw0BhZ8oFbxlaxZ27TiZyggODor8%3D",
    //         },
    //         {
    //             date: "2024-11-29",
    //             status: 1,
    //             status_text: "Actif",
    //             status_description: "Clôture de l'Onboarding",
    //             processed_by_name: "Foued SAIDANE",
    //             processed_by_avatar:
    //                 "https://asenditbackenddevstorage.blob.core.windows.net/documents/asendit/users/16/profile_photo/profile.jpeg?se=2025-01-31T13%3A43%3A53Z&sp=r&sv=2021-06-08&sr=b&sig=nCAY99NXJW4QKeUCw0BhZ8oFbxlaxZ27TiZyggODor8%3D",
    //         },
    //         {
    //             date: "2024-11-29",
    //             status: -3,
    //             status_text: "En onboarding",
    //             status_description: "Démarrage de l'Onboarding",
    //             processed_by_name: "Foued SAIDANE",
    //             processed_by_avatar:
    //                 "https://asenditbackenddevstorage.blob.core.windows.net/documents/asendit/users/16/profile_photo/profile.jpeg?se=2025-01-31T13%3A43%3A53Z&sp=r&sv=2021-06-08&sr=b&sig=nCAY99NXJW4QKeUCw0BhZ8oFbxlaxZ27TiZyggODor8%3D",
    //         },
    //         {
    //             date: "2024-09-27",
    //             status: 1,
    //             status_text: "Actif",
    //             status_description: "Clôture de l'Onboarding",
    //             processed_by_name: "Foued SAIDANE",
    //             processed_by_avatar:
    //                 "https://asenditbackenddevstorage.blob.core.windows.net/documents/asendit/users/16/profile_photo/profile.jpeg?se=2025-01-31T13%3A43%3A53Z&sp=r&sv=2021-06-08&sr=b&sig=nCAY99NXJW4QKeUCw0BhZ8oFbxlaxZ27TiZyggODor8%3D",
    //         },
    //         {
    //             date: "2024-09-27",
    //             status: -3,
    //             status_text: "En onboarding",
    //             status_description: "Démarrage de l'Onboarding",
    //             processed_by_name: "Foued SAIDANE",
    //             processed_by_avatar:
    //                 "https://asenditbackenddevstorage.blob.core.windows.net/documents/asendit/users/16/profile_photo/profile.jpeg?se=2025-01-31T13%3A43%3A54Z&sp=r&sv=2021-06-08&sr=b&sig=235jNQ/Ulh%2B890MUHArgQiBVRITswso2MLc50XBs42I%3D",
    //         },
    //         {
    //             date: "2024-09-22",
    //             status: 0,
    //             status_text: "En pré-onboarding",
    //             status_description: "Administratif avant le jour d'arrivée",
    //             processed_by_name: "",
    //             processed_by_avatar: "",
    //         },
    //     ],
    //     sharepoint_url:
    //         "https://asendit.sharepoint.com/sites/Yeetch-Documentsdel%27application",
    //     onboarding_status_code: "suivi",
    //     onboarding_status_text: "Suivi",
    // };

    const { isLoading: loadingArchivedUser, data: ArchivedUser } = useQuery(
        ["getOffboardingArchivedUser", user?.id],
        (args) => {
            const id = args.queryKey.at(1);
            return _getOffboardingArchiveduser(id);
        },
        {
            enabled: !!user.id, // Only run query when user_id is available
        }
    );

    const { mutate: mutate_relance_onboarding_user } = useMutation(() =>
        relance_onboarding_user_from_offboarding()
    );

    const methods = useForm({
        mode: "onChange",
        defaultValues: {
            status: "onboarding",
            startDate: "",
            arrived_date: "",
            end_date: "",
        },
    });
    const { handleSubmit, reset, control, watch } = methods;

    const startDate = watch("startDate", "");
    const arrived_date = watch("arrived_date", "");
    const end_date = watch("end_date", "");
    const isValid = startDate.trim() !== "" && arrived_date.trim() !== "";
    // && end_date.trim() !== "";

    const onSubmit_relance_onboarding = (value) => {
        mutate_relance_onboarding_user(
            {
                user_id: user.id,
                status: value.status,
                startDate: value.startDate,
                arrived_date: value.arrived_date,
                end_date: value.end_date,
            },
            {
                onSuccess: (res) => {
                    if (res.success) {
                        toast.setShow({
                            visible: true,
                            content: "L'onboarding a été relancé avec succès",
                            level: "success",
                        });
                        reset();
                    } else {
                        toast.setShow({
                            visible: true,
                            content: res.message,
                            level: "danger",
                        });
                    }
                },
            }
        );
    };

    if (loadingArchivedUser) {
        return <Loader label="Chargement des données..." />;
    }
    return (
        <Flex styles={{ backgroundColor: "#F5F5F5" }}>
            <Container column>
                <DetailOffboardingHeader
                    activeTab={activeTab}
                    AgencyId={user?.agency?.id}
                />
                <Flex
                    fill
                    styles={{
                        backgroundColor: "#F5F5F5",
                        gap: "32px",
                        paddingInline: "16px",
                        flex: 1,
                        marginTop: "22px",
                    }}
                >
                    <RightContent gap={"gap.large"} space="between">
                        <Flex fill column>
                            <Flex fill space="between">
                                <UserCard user={user} />
                                <BadgeFlex vAlign="center" hAlign="center">
                                    <BadgeText
                                        content={
                                            ArchivedUser?.offboarding_status_text
                                        }
                                    />
                                </BadgeFlex>
                            </Flex>

                            <Flex
                                space="between"
                                styles={{ gap: "40px", marginTop: "40px" }}
                                fill
                            >
                                <DetailOffboardingArchivedCard
                                    archivedUserDetails={ArchivedUser}
                                />
                                <OffBoardingArchivedActions
                                    ArchivedUser={ArchivedUser}
                                />
                            </Flex>

                            <Flex
                                styles={{
                                    maxWidth: "360px",
                                }}
                                hAlign="center"
                                fill
                            >
                                <Button
                                    // styles={{ marginBottom: "40px" }}
                                    size="medium"
                                    icon={<Image src={Sharepoint} />}
                                    content="Accéder aux documents"
                                    onClick={() =>
                                        window.open(
                                            `${ArchivedUser?.sharepoint_url}`,
                                            "_blank"
                                        )
                                    }
                                />
                            </Flex>
                            {/* sharepoint */}
                        </Flex>
                    </RightContent>
                    <LeftContent fill>
                        <HistoriqueArchivedCollab ArchivedUser={ArchivedUser} />
                    </LeftContent>
                </Flex>
                {/* <FooterAction hAlign="end" gap="gap.small">
                    <Dialog
                        confirmButton={{
                            content: "Relancer l'Onboarding",
                            flat: true,
                            onClick: () =>
                                handleSubmit(onSubmit_relance_onboarding)(),
                            disabled: !isValid,
                        }}
                        cancelButton={{
                            content: "Annuler",
                            flat: true,
                            onClick: () => reset(),
                        }}
                        header="Relancer l'onboarding ?"
                        content={
                            <FormProvider {...methods}>
                                <form
                                    onSubmit={handleSubmit(
                                        onSubmit_relance_onboarding
                                    )}
                                >
                                    <Flex gap="gap.large" fill column>
                                        <Text content="Quel autre statut souhaitez-vous attribuer au collaborateur ?" />
                                        <Flex
                                            gap="gap.large"
                                            vAlign="center"
                                            fill
                                        >
                                            <Badge>
                                                <Text content="Archivé" />
                                            </Badge>

                                            <ArrowRightIcon />

                                            <Controller
                                                name="status"
                                                control={control}
                                                render={({
                                                    field: {
                                                        onChange,
                                                        ...field
                                                    },
                                                }) => (
                                                    <Dropdown
                                                        fill
                                                        items={["onboarding"]}
                                                        {...field}
                                                        onChange={(_, i) =>
                                                            onChange(i.value)
                                                        }
                                                    />
                                                )}
                                            />
                                        </Flex>
                                        <Input
                                            required
                                            {...methods.register("startDate")}
                                            fluid
                                            styles={{
                                                width: "196px",
                                            }}
                                            label="A partir de :"
                                            type="date"
                                        />
                                        <Flex gap="gap.medium" fill>
                                            <Input
                                                required
                                                {...methods.register(
                                                    "arrived_date"
                                                )}
                                                styles={{ width: "196px" }}
                                                fluid
                                                label="Date d'arrivée :"
                                                type="date"
                                            />
                                            <Input
                                                required
                                                {...methods.register(
                                                    "end_date"
                                                )}
                                                styles={{ width: "196px" }}
                                                fluid
                                                label="Date de fin (optionnel)"
                                                type="date"
                                            />
                                        </Flex>
                                    </Flex>
                                </form>
                            </FormProvider>
                        }
                        trigger={
                            <Button
                                iconPosition="after"
                                icon={<PersonArrowRight20Regular />}
                                flat
                                primary
                                content="Relancer l'onboarding"
                            />
                        }
                    />
                </FooterAction> */}
            </Container>
        </Flex>
    );
};

const Badge = styled(Flex)`
    background-color: #e8ebfa;
    border-radius: 4px;
    padding: 8px 16px;
    margin-top: 8px;
    color: #5b5fc7;
    font-weight: 600;
`;

const BadgeText = styled(Text)`
    color: #4f52b2;
    font-weight: 700;
`;

const BadgeFlex = styled(Flex)`
    border-radius: 4px;
    border: 1px solid #fff;
    padding: 4px 18px;
    background-color: #e8ebfa;
    height: 24px;
`;

const Label = styled(Text)`
    color: #616161;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
const RightContent = styled(Flex)`
    width: 890px;
    padding: 24px 16px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;
const LeftContent = styled(Flex)`
    width: 418px;
`;

const FooterAction = styled(Flex)`
    margin-top: 30px;
    padding: 24px;
    border-bottom: 1px solid #d1d1d1;
    background: #fff;
    box-shadow: 0px -1.2px 3.6px 0px rgba(0, 0, 0, 0.11),
        0px -6.4px 14.4px 0px rgba(0, 0, 0, 0.13);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px;
    max-width: 1440px;
    margin: 0 auto;
`;
